export default __webpack_public_path__ + "static/media/timezone_icon.7392ae59.svg";